import {
  AfterViewChecked,
  AfterViewInit,
  Component,
  ElementRef,
  EventEmitter,
  HostListener,
  Input,
  OnDestroy,
  OnInit,
  Output,
  TemplateRef,
  ViewChild,
  ViewContainerRef
} from '@angular/core';
import {PlatformQueryService} from '@core/services/platform-query.service';
import {
  ContextMenuAction,
  IconViewModel,
  IconViewResponse,
  multipleSelectorContextMenu,
  PermissionList
} from '@features/file-manager/models/file-manager.model';
import {PlatformQuery} from '@shared/models/platform-query/platform-query';
import {filter, map, take, takeUntil} from 'rxjs/operators';
import {InvalidateSubject} from '@shared/helpers/invalidate.subject';
import {fromEvent, Subject, Subscription} from 'rxjs';
import {Overlay, OverlayRef} from '@angular/cdk/overlay';
import {TemplatePortal} from '@angular/cdk/portal';
import {PlatformCommand} from '@shared/commands/command-base';
import {FileStoreCommonService} from '@features/file-manager/services/file-store-common.service';
import {DialogService} from '@shared/services/dialog-service';
import {ShareItemService} from '@shared/services/share-item.service';
import {FileManagerService} from '@features/file-manager/services/file-manager.service';
import {GraphQLService} from '@core/services/graphql.service';
import {TranslationService} from '@features/translation/services/translation.service';
import {Store} from '@ngrx/store';
import {IQueryState} from '@shared/store/reducers/query.reducer';
import {SnackBarService} from '@core/services/snack-bar.service';
import {MatDialog} from '@angular/material/dialog';
import {PlatformSidebarState} from '@shared/components/platform-sidebar/store/platform-sidebar.reducer';
import {
  getRightSideBarCurrentComponent,
  getRightSideBarIsFolded
} from '@shared/components/platform-sidebar/store/platform-sidebar.selector';
import {FileSelectionChangedAction} from '@features/file-manager/store/actions/file-manager.actions';
import {getFileStoreSelectedItems} from '@features/file-manager/store/selectors/file-manager.selectors';
import {FileManagerState} from '@features/file-manager/store/reducers/file-manager.reducer';
import {MagicLinkModel} from '@shared/models/platform-tool-models';
import {getCurrentPlatformLink, ParticleState} from '@shared/store/reducers/particle.reduer';
import {Api} from '@shared/constants/common-field.constants';
import {SocketClusterService} from '@core/services/socket-cluster.service';
import {CommandService} from '@core/services/command.service';
import {ParticleCacheService} from '@core/services/particle-cache.service';
import {of} from "rxjs";
import {FuseSplashScreenService} from '@barebone-fuse-services/splash-screen.service';


@Component({
    standalone: false,
    selector: 'app-icon-view',
  templateUrl: './icon-view.component.html',
  styleUrls: ['./icon-view.component.scss']
})
export class IconViewComponent implements OnInit, OnDestroy, AfterViewInit, AfterViewChecked {
  @ViewChild('gridContent') elementView: ElementRef;
  @Input() invalidateSubject: InvalidateSubject = new InvalidateSubject();
  @Input() navigateInvalidateSubject: InvalidateSubject;
  @Input() parentId: string;
  @Input() isClientDrive: boolean;
  @Input() queryName: string;
  @Input() showHiddenItems?: boolean;
  @Input() showSelectedItem = true;
  @Input() fileExtensionTypes = [];
  @Input() hideFiles?: boolean;
  @Input() hideFolders?: boolean;
  @Input() foldersSelectable: boolean;
  @Input() isDialogView = false;
  @Input() isFileSelector = false;
  @Input() tags?: string;
  @Input() hasDragAndDrop?: boolean;
  @Input() selectOnlyCurrentDirectoryFiles = false; // In Excel file selection, we need only current directory files
  @Input() isThumbnailView = false;
  @Output() iconViewItemClicked: EventEmitter<IconViewModel> = new EventEmitter<IconViewModel>();
  @Output() iconViewItemDblClicked?: EventEmitter<IconViewModel> = new EventEmitter<IconViewModel>();
  @Output() parentChanged = new EventEmitter<{ parentId: string, driveId: string }>();
  // This emitter is mainly for Dialog view
  @Output() selectedItemEvent?: EventEmitter<IconViewModel[]> = new EventEmitter<IconViewModel[]>();
  ngUnsubscribe$ = new Subject<void>();
  @Input() selectedList: IconViewModel[] = [];
  iconViewResponse: IconViewResponse;
  columnSize: number;
  iconViewWidth: number;
  sub: Subscription;
  selectedItem: IconViewModel;
  selectedItemForComment: IconViewModel;
  emptyContentMessageTitle: string;
  fileTypes = '';
  emptyContentTitle: string;
  emptyContentSubtitle: string;
  // Pagination
  pageSize = 120;
  pageNo = 0;
  pageCount = 1;
  infiniteScrollDisabled = false;
  thumbnailViewResponse: any;

  // Context menu
  outer = false;
  inside = false;

  @ViewChild('userMenu', {read: TemplateRef, static: true}) userMenu: TemplateRef<unknown>;
  overlayRef: OverlayRef | null;
  magicLinkModel: MagicLinkModel;
  timer: any;
  showSync: boolean = true;
  isDriveIdSubscribed: boolean = false;
  driveId = '';
  currentParentId: string;
  @Output() iconViewItemDataFetched = new EventEmitter<IconViewResponse>();
  multiSelectedContextOptons: any;

  constructor(private platformQueryService: PlatformQueryService,
              private overlay: Overlay,
              private viewContainerRef: ViewContainerRef,
              private fileStoreCommonService: FileStoreCommonService,
              private dialogService: DialogService,
              private shareItemService: ShareItemService,
              private fileManagerService: FileManagerService,
              private socketClusterService: SocketClusterService,
              protected snackBarService: SnackBarService,
              private commandService: CommandService,
              private store: Store<IQueryState>,
              private fileManagerStore: Store<FileManagerState>,
              private graphQLService: GraphQLService,
              private translationService: TranslationService,
              private particleStore: Store<ParticleState>,
              private fuseSplashScreenService: FuseSplashScreenService,
              protected dialog: MatDialog,
              private platformSidebarStore: Store<PlatformSidebarState>) {
  }

  ngOnInit(): void {
    // this.fileExtensionTypes.push('.frm');
    this.currentParentId = this.parentId;
    if (!this.navigateInvalidateSubject) {
      this.navigateInvalidateSubject = new InvalidateSubject();
    }
    if (!this.isDialogView) {
      this.fileManagerStore.select(getFileStoreSelectedItems).pipe(takeUntil(this.ngUnsubscribe$)).subscribe(selectedItems => {
        this.selectedList = selectedItems ? selectedItems : [];
        selectedItems?.forEach(o => {
          console.log(o.name);
        });
      });
    }
    this.particleStore.select(getCurrentPlatformLink).pipe(takeUntil(this.ngUnsubscribe$))
      .subscribe((platformLink: any) => {
        this.magicLinkModel = platformLink;
      });
    this.iconViewWidth = 135;
    this.getItemList(this.parentId, 0);
    if (this.isDialogView) {
      this.navigateInvalidateSubject.getObservale().pipe(takeUntil(this.ngUnsubscribe$)).subscribe((items) => {
        if (this.selectOnlyCurrentDirectoryFiles) {
          this.selectedList = [];
        }
        try {
          const res = JSON.parse(items);
          console.table(res);
          this.getItemList(res['ParentId'], 0);
        } catch (err) {
          this.getItemList(items, 0);
        }
      });
    }

    this.platformSidebarStore.select(getRightSideBarIsFolded).pipe(takeUntil(this.ngUnsubscribe$)).subscribe(isFolded => {
      if (isFolded) {
        this.selectedItemForComment = null;
      }
    });
    this.platformSidebarStore.select(getRightSideBarCurrentComponent).pipe(takeUntil(this.ngUnsubscribe$))
      .subscribe(currentRightSideComponentInfo => {
        if (this.selectedItemForComment === null) {
          this.selectedItemForComment = null;
        }
      });
    this.invalidateSubject.getObservale().pipe(takeUntil(this.ngUnsubscribe$)).subscribe(state => {
      if (state.indexOf('OrbitaxDrive') >= 0) {
        this.getItemList(this.parentId, 0);
      } else {
        this.getItemList(this.parentId, 0);
      }
    });
  }

  ngAfterViewInit(): void {
    this.calculateColumnSize();
  }

  ngAfterViewChecked(): void {
    this.calculateColumnSize();
  }

  calculateColumnSize() {
    if (this.elementView) {
      this.columnSize = Math.floor(this.elementView.nativeElement.offsetWidth / this.iconViewWidth);
    }
  }

  getItemList(parentId: string, pageNo: number) {
    console.log('Inside Query: [IconViewComponent] showHiddenItems', this.showHiddenItems);
    const query = new PlatformQuery();
    query.name = 'IconViewQuery';
    if (this.queryName) {
      query.name = this.queryName;
    }
    query.api = Api.FileStoreApi;
    query.isCamelCase = true;
    query.fieldValues['ParentId'] = parentId;
    query.fieldValues['IsClientDrive'] = this.isClientDrive;
    query.fieldValues['PageSize'] = this.pageSize;
    query.fieldValues['PageNo'] = pageNo;
    query.fieldValues['ShowHiddenItems'] = this.showHiddenItems;
    query.fieldValues['FileExtensionTypes'] = this.fileExtensionTypes;
    query.fieldValues['IsFileSelector'] = this.isFileSelector;
    if (this.hideFiles) {
      query.fieldValues['HideFiles'] = this.hideFiles;
    }
    if (this.hideFolders) {
      query.fieldValues['HideFolders'] = this.hideFolders;
    }
    if (this.tags && this.tags.length) {
      query.fieldValues['Tags'] = this.tags;
    }

    // this.fuseSplashScreenService.show();
    this.platformQueryService.executeQuery(query).pipe(take(1)).subscribe(response => {
      // this.fuseSplashScreenService.hide();
      const iconViewResponse = response.fieldValues['IconViewResponse'];
      this.iconViewItemDataFetched.emit(iconViewResponse);
      iconViewResponse.items.forEach(item => {
        item.isSelected = this.selectedList.some(selectedItem => selectedItem.itemId === item.itemId);
      });
      if (this.pageNo === 0 || this.currentParentId !== parentId) {
        this.pageNo = 0;
        this.infiniteScrollDisabled = false;
        this.iconViewResponse = iconViewResponse;
        this.currentParentId = parentId;
        this.pageCount = iconViewResponse.pageCount;
      } else {
        this.iconViewResponse.items = [...this.iconViewResponse.items, ...iconViewResponse.items];
      }
      this.getEmptyContentMessageTitle();
      this.setEmptyContentMessage();
      this.subscribeToDriveId(iconViewResponse.items);
      this.parentChanged.emit({parentId: parentId, driveId: iconViewResponse.driveId});
      if (this.isThumbnailView) {
        this.getThumbnails();
      }
    });
  }

  onIconViewItemClicked(iconResponse: IconViewModel) {
    if (iconResponse.parentId === 'trash') {
      return;
    }
    this.parentChanged.emit({parentId: iconResponse.parentId, driveId: iconResponse.driveId});
    this.iconViewItemClicked.emit(iconResponse);
    this.itemSelectionEventEmit(iconResponse);
    if (iconResponse.type === 'File') {
      // we wont show activity log
      //this.onSelectItem(iconResponse);
    }
    this.close();
  }

  updateSelection(item: IconViewModel) {
    this.selectedItemForComment = null;
    item.isSelected = !item.isSelected;
    this.filterSelectedList(item);
    if (!this.isDialogView) {
      this.fileManagerStore.dispatch(new FileSelectionChangedAction(this.selectedList));
    }
    this.selectedItemEvent.emit(this.selectedList);
  }

  itemSelectionEventEmit(item: IconViewModel) {
    if (item.type === 'Folder' || item.type === 'SharedDrive') {
      this.selectedItemEvent.emit([item]);
    }
  }

  removeSelectedItem(item: IconViewModel) {
    item.isSelected = false;
    this.selectedList = this.selectedList.filter(iconViewModel => iconViewModel.itemId !== item.itemId);
    this.selectedItemEvent.emit(this.selectedList);
  }

  onScroll() {
    if (this.pageNo + 1 >= this.pageCount) {
      this.infiniteScrollDisabled = true;
      return;
    }
    this.getItemList(this.parentId, ++this.pageNo);
  }

  checkInside($event: MouseEvent, item: IconViewModel): void {
    $event.stopPropagation();
    if (this.isDialogView) {
      return;
    }
    console.log('clicked inside');
    //
    const query = new PlatformQuery();
    query.name = 'DirectoryEntryContextMenuQuery';
    query.api = Api.FileStoreApi;
    // query.fieldValues['ItemId']=item.itemId;
    if(this.selectedList.length > 0){
      query.fieldValues['ItemIds']=this.selectedList.map(o => o.itemId);
    } else {
      query.fieldValues['ItemIds']=[item.itemId];
    }
    query.fieldValues['Tags']=this.tags;
    if(this.selectedList.length > 1){
      this.platformQueryService.executeQuery(query).subscribe(response => {
        if(response.fieldValues['MenuItems'] && response.fieldValues['MenuItems'].length > 0) {
          this.multiSelectedContextOptons = response.fieldValues['MenuItems'];
          this.open($event, item);
        }
      });
    } else {
      if(!item.contextMenuActions || !item.contextMenuActions.length) {
        this.platformQueryService.executeQuery(query).subscribe(response => {
          this.multiSelectedContextOptons = null;
          item.contextMenuActions = response.fieldValues['MenuItems'];
          this.open($event, item);
        });
      } else {
        this.open($event, item);
      }
    }
  }

  @HostListener('document:contextmenu', ['$event']) clickedOutside($event: MouseEvent): void {
    console.log('CLICKED OUTSIDE');
    // this.open($event, { name: 'outsider context' });
    this.close();
  }

  open({x, y}: MouseEvent, item: IconViewModel): void {
    this.close();
    const positionStrategy = this.overlay
      .position()
      .flexibleConnectedTo({x, y})
      .withPositions([
        {
          originX: 'start',
          originY: 'top',
          overlayX: 'start',
          overlayY: 'top'
        }
      ]);

    this.overlayRef = this.overlay.create({
      positionStrategy,
      scrollStrategy: this.overlay.scrollStrategies.close()
    });

    this.overlayRef.attach(
      new TemplatePortal(this.userMenu, this.viewContainerRef, {
        $implicit: item
      })
    );
    this.selectedItem = item;

    this.sub = fromEvent<MouseEvent>(document, 'click')
      .pipe(
        filter(event => {
          const clickTarget = event.target as HTMLElement;
          return (
            !!this.overlayRef &&
            !this.overlayRef.overlayElement.contains(clickTarget)
          );
        }),
        take(1)
      )
      .subscribe(event => {
        this.close();
        // console.log("sub", event.x, event.y);
      });
    if (item.contextMenuActions.length === 0) {
      this.close();
    }
  }

  markStar(item: IconViewModel): void {
    console.log('contextMenuItem', item);
    const command = new PlatformCommand('ToggleStarContentCommand', 'FileStoreApi');
    command.fieldValues['ItemId'] = item.itemId;
    command.fieldValues['IsDeleted'] = false;
    command.fieldValues['IsClientDrive'] = this.isClientDrive;
    command.fieldValues['IsFavorite'] = item.isFavorite;
    command.fieldValues['ParentId'] = item.parentId;
    command.fieldValues['Type'] = item.type;
    const response = this.fileStoreCommonService.executeCommand(command);
    response.subscribe(res => {
      const itemId = res.fieldValues['ItemId'];
      const isFavourite = res.fieldValues['IsFavorite'];
      this.iconViewResponse.items.forEach(o => {
        if (o.itemId === itemId) {
          o.isFavorite = isFavourite;
        }
      });
      this.invalidateSubject.invalidate();
    });

    this.close();
  }

  close(): void {
    // tslint:disable-next-line:no-unused-expression
    this.sub && this.sub.unsubscribe();
    if (this.overlayRef) {
      this.overlayRef.dispose();
      this.overlayRef = null;
    }
    this.outer = false;
    this.inside = false;
  }

  ngOnDestroy() {
    this.ngUnsubscribe$.next();
    this.ngUnsubscribe$.complete();
    this.socketClusterService.unsubscribeChannel(this.driveId);
    clearTimeout(this.timer);
  }

  onMenuAction(action: ContextMenuAction, item: IconViewModel) {
    console.log('Menu Action:', action, item);
    this.close();
    if (action.type === 'Move') {
      if (this.selectedList.length === 0) {
        this.fileStoreCommonService.OpenMoveDialog(this.isClientDrive, [item]).subscribe(() => {
          this.invalidateSubject.invalidate();
          this.selectedList = [];
        });
      } else {
        this.fileStoreCommonService.OpenMoveDialog(this.isClientDrive, this.selectedList).subscribe(() => {
          this.invalidateSubject.invalidate();
          this.selectedList = [];
        });
      }
      if (!this.isDialogView) {
        this.fileManagerStore.dispatch(new FileSelectionChangedAction(this.selectedList));
      }
      return;
    }

    if (action.type === 'DeleteMultiple' && this.selectedList.length > 0) {
      this.fileStoreCommonService.openDeleteFileOrFolderConfirmationDialog(this.selectedList).subscribe(() => {
        this.invalidateSubject.invalidate();
        this.selectedList = [];
      });
      if (!this.isDialogView) {
        this.fileManagerStore.dispatch(new FileSelectionChangedAction(this.selectedList));
      }
      return;
    }

    if (action.type === 'DownloadAsZipMultiple' && this.selectedList.length > 0) {
      this.fileStoreCommonService.downloadAsZip(this.selectedList);
      this.selectedList.forEach(selectedItem => {
        selectedItem.isSelected = false;
      });
      this.selectedList = [];
      if (!this.isDialogView) {
        this.fileManagerStore.dispatch(new FileSelectionChangedAction(this.selectedList));
      }
      return;
    }
    if (action.type === 'Open') {
      this.fileStoreCommonService.executeFormAdditionalCommand({
        itemId: item.itemId,
        driveId: item.driveId,
        name: item.name
      }, item.type, this.magicLinkModel);
      return;
    }
    this.fileStoreCommonService.handleActions(action, item, this.invalidateSubject, this.magicLinkModel);
    this.invalidateSubject.invalidate();
  }

  onSelectItem(item: IconViewModel) {
    item.contextMenuActions.forEach(actions => {
      if (actions.type === 'ShowActivity' && item.parentId !== 'trash') {
        console.log('Show Activity');
        this.fileStoreCommonService.openCommentDialog(item);
        if (this.selectedList.length === 0) {
          this.selectedItemForComment = item;
        }
      }
    });
    // this.selectedItemEvent.emit([item]);
  }

  getMultipleSelectActionMenu() {
    let lowestPermission = 0;
    PermissionList.some(permission => {
      const hasPermissionToItems = this.selectedList.every((o: IconViewModel) =>
        o.userPermission >= permission);
      if (hasPermissionToItems) {
        lowestPermission = permission;
        return true;
      }
    });
    const availableSelectorContextMenu = multipleSelectorContextMenu.filter(menu => {
      if (menu.tags.length > 0) {
        let hasTagInAllItems = true;
        menu.tags.forEach(tag => {
          hasTagInAllItems = this.selectedList.every((o: IconViewModel) =>
            o.tag.split(',').find(t => t === tag) !== undefined);
          if (!hasTagInAllItems) {
            return;
          }
        });
        if (!hasTagInAllItems) {
          return false;
        }
      }
      return true;
    });
    return availableSelectorContextMenu.filter(menu => menu.minimumPermission <= lowestPermission);
  }

  getContextMenuActions(item: IconViewModel) {
    console.log('item selected:', item);
    if (this.selectedList.length > 1) {
      // return this.getMultipleSelectActionMenu();
      return this.multiSelectedContextOptons;
    } else {
      return item.contextMenuActions;
    }
  }

  setEmptyContentMessage() {
    this.emptyContentTitle = this.hasDragAndDrop || !this.iconViewResponse.parentId
      ? 'Add your files here...'
      : this.emptyContentMessageTitle;

      this.emptyContentSubtitle = this.hasDragAndDrop
        ? 'Please drag and drop files from your computer here or use the \'Upload File\' option under the Actions menu' :
        (this.iconViewResponse.parentId
          ? (this.iconViewResponse.fileTypes.length === 1 && this.fileTypes === 'Questionnaire'
            ? 'Please convert a PDF or Excel file into a Questionnaire before using this option'
            : 'Please use the \'Upload File\' option under the Actions menu') : '');

  }

  // Selected List for dialog View
  private filterSelectedList(item: IconViewModel) {
    if (item.isSelected) {
      this.selectedList = [...this.selectedList, item];
    } else {
      this.selectedList = this.selectedList.filter(iconViewModel => iconViewModel.itemId !== item.itemId);
    }
  }

  private getEmptyContentMessageTitle() {
    if (this.iconViewResponse.items?.length === 0) {
      if (this.iconViewResponse.fileTypes?.length === 1) {
        this.fileTypes = this.iconViewResponse.fileTypes[0];
      }
      this.emptyContentMessageTitle = `No ${this.fileTypes} files found`;
    }
  }

  private subscribeToDriveId(items: any) {
    if (!this.isDriveIdSubscribed && items && items.length > 0) {
      this.isDriveIdSubscribed = true;
      this.driveId = items[0].driveId;
      this.socketClusterService.subscribeToChannel(this.driveId).pipe(takeUntil(this.ngUnsubscribe$)).subscribe((notification) => {
        if (notification.Type === 'ThumbnailGeneration' && notification.Payload?.HasGeneratedAnyThumbnail) {
          this.getThumbnails();
        } else if (notification.Type !== 'ThumbnailGeneration') {
          this.updateDataExtractionStatus(notification.payload);
        }
      });
    }
  }

  private updateDataExtractionStatus(payload: any) {
    console.log('updated payload information:', payload, this.iconViewResponse.items);
    let item = this.iconViewResponse.items.find(i => i.itemId === payload.id);
    if (item) {
      item.dataExtractionStatus = payload.fieldValues ? payload.fieldValues.DataExtractionStatus : '';
      item.classId = payload.fieldValues ? payload.fieldValues.ClassId : '';
    }
  }

  private getThumbnails() {
    const query = new PlatformQuery();
    query.name = 'ThumbnailViewQuery';
    query.api = Api.FileStoreApi;
    query.fieldValues['IconViewResponse'] = this.iconViewResponse;

    this.platformQueryService.executeQuery(query).pipe(take(1)).subscribe(response => {
      console.log('ThumbnailViewResponse: ', response);
      this.thumbnailViewResponse = response;
      if (response.fieldValues['HasAllThumbnails'] === false) {
        const command = new PlatformCommand('GenerateThumbnailCommand', Api.FileStoreApi);
        command.fieldValues['IconViewResponse'] = this.iconViewResponse;
        command.waitForResponse = false;
        this.commandService.executePlatformCommand(command).pipe(take(1)).subscribe( response => {
        });
      }

    });
  }
}

